export default "__VITE_ASSET__ef7OViWS__"